import { W9FormData, W9TinValues } from '@bybeam/platform-types';
import RadioGroup from '@platform-ui-common/components/RadioGroup/index.js';
import TextInput from '@platform-ui-common/components/TextInput/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import { fieldUpdate } from '@platform-ui-common/hooks/useForm/index.js';
import { FormProps } from '@platform-ui-common/types/index.js';
import { Mask } from '@platform-ui-common/utilities/format.js';
import { AddressFields } from '@platform-ui/application/components/index.js';
import cx from 'classnames';
import EINInput from './EINInput.js';
import Panel from './Panel.js';

const IndividualTaxFormClassification = ({
  formData,
  dispatch,
  errors,
}: FormProps<W9FormData>): JSX.Element => {
  const tinItems = [
    { label: 'Social security number', value: W9TinValues.SSN },
    { label: 'Employer identification number', value: W9TinValues.EIN },
  ];

  return (
    <Panel>
      <Typography variant="body">
        Please complete this section as shown on your income tax return:
      </Typography>
      <TextInput
        id="full-name"
        required
        label="Full Name"
        value={formData.name ?? ''}
        onChange={(value: string): void => dispatch(fieldUpdate('name', value))}
        error={errors.name as string}
      />
      <AddressFields
        id="w9-street-address"
        dispatch={dispatch}
        errors={errors}
        formData={formData}
      />
      <div className={cx('flex max-w-full items-start w-field')}>
        <Typography variant="body">Taxpayer Identification Number (TIN):*</Typography>
      </div>
      <RadioGroup
        name="tin"
        selectedValue={formData.tin}
        onChange={(value: string): void => {
          dispatch(fieldUpdate('tin', value as W9TinValues));
          dispatch(fieldUpdate('ssn', undefined));
          dispatch(fieldUpdate('ein', undefined));
        }}
        items={tinItems}
        error={!!errors.tin}
      />
      {formData.tin === W9TinValues.SSN && (
        <TextInput
          id="ssn"
          required
          label="Enter social security number"
          value={formData.ssn ?? ''}
          onChange={(value: string): void => dispatch(fieldUpdate('ssn', value))}
          error={errors.ssn as string}
          mask={Mask.SSN}
        />
      )}
      {formData.tin === W9TinValues.EIN && (
        <EINInput formData={formData} dispatch={dispatch} errors={errors} />
      )}
    </Panel>
  );
};

export default IndividualTaxFormClassification;
